var $252051c6344b001f$exports = {};
{
    const navItems = document.querySelectorAll('a.navigation__link.-gridItem');
    const sections = [];
    navItems.forEach((item)=>{
        const sectionId = item.href.substring(item.href.indexOf("#") + 1);
        const matchingSection = document.getElementById(sectionId);
        if (matchingSection) {
            sections.push(matchingSection);
            item.addEventListener('click', toggleSections);
        }
    });
    function toggleSections(e) {
        e.preventDefault();
        currentItem = document.querySelector('.navigation__link.-gridItem.-selected');
        if (currentItem !== this) {
            currentItem.classList.toggle('-selected');
            this.classList.toggle('-selected');
        }
        const href = this.href;
        const currentSection = document.querySelector('.program-section.-show');
        if (href.includes('#')) {
            const hash = href.substring(href.indexOf("#") + 1);
            const section = document.getElementById(hash);
            section.classList.toggle('-show');
            currentSection.classList.toggle('-show');
            return false;
        }
    }
    loadSections();
    function loadSections() {
        const hash = window.location.hash.substring(1);
        let section;
        if (hash.length !== 0) {
            section = document.getElementById(hash);
            navItems.forEach((item)=>{
                const sectionId = item.href.substring(item.href.indexOf("#") + 1);
                if (sectionId === hash) item.classList.toggle('-selected');
            });
        } else navItems.item(0).classList.toggle('-selected');
        sections.forEach(setClasses, section);
    }
    function setClasses(element) {
        if (this instanceof Window) {
            element.classList.add('program-section');
            document.getElementById('overview').classList.toggle('-show');
        } else if (element === this) element.classList.add('program-section', '-show');
        else element.classList.add('program-section');
    }
    //Variables used to grab the Main, Aside, Inquiry Form, and Navigation Grid elements.
    const main = document.querySelector('main.grid__main');
    const aside = document.querySelector('aside.grid__sidebar.-right');
    const inquiryForm = aside.querySelector('div.sidebar.-inquiryForm');
    const navGrid = main.querySelector('div.navigation.-programNavGrid');
    //The minimum width at which the inquiry form will shift from the sidebar to the top of the main content.
    const minWidth = 1025;
    //The function that shifts the inquiryForm from the sidebar to the atop the main content and back
    const inquiryShift = function(event) {
        if (event) event.preventDefault;
        //Shifts the inquiry form to above the Navigation Grid
        if (this.innerWidth < minWidth && aside.contains(inquiryForm)) {
            main.insertBefore(inquiryForm, navGrid);
            inquiryForm.classList.add('-shifted');
        //Shifts the inquiry form back to the top of the right sidebar.
        } else if (this.innerWidth >= minWidth && main.contains(inquiryForm)) {
            aside.insertBefore(inquiryForm, aside.children[0]);
            inquiryForm.classList.remove('-shifted');
        }
    };
    //Fire inquiryShift on page load
    inquiryShift();
    //Fire inquiryShift when screen resizes
    window.addEventListener("resize", inquiryShift);
}

//# sourceMappingURL=program.js.map
